import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getSafeId } from "./auth-service-tools179.js";
import { getRadius } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { getContrastColor } from "./auth-service-tools214.js";
import { getAutoContrastValue } from "./auth-service-tools215.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { TabsProvider } from "./auth-service-tools412.js";
import { TabsList } from "./auth-service-tools413.js";
import { TabsPanel } from "./auth-service-tools414.js";
import { TabsTab } from "./auth-service-tools415.js";
import classes from "./auth-service-tools416.js";
import { useId } from "./auth-service-tools271.js";
import { useUncontrolled } from "./auth-service-tools323.js";
const VALUE_ERROR = "Tabs.Tab or Tabs.Panel component was rendered with invalid value or without value";
const defaultProps = {
  keepMounted: true,
  orientation: "horizontal",
  loop: true,
  activateTabWithKeyboard: true,
  allowTabDeactivation: false,
  unstyled: false,
  inverted: false,
  variant: "default",
  placement: "left"
};
const varsResolver = createVarsResolver((theme, _ref) => {
  let {
    radius,
    color,
    autoContrast
  } = _ref;
  return {
    root: {
      "--tabs-radius": getRadius(radius),
      "--tabs-color": getThemeColor(color, theme),
      "--tabs-text-color": getAutoContrastValue(autoContrast, theme) ? getContrastColor({
        color,
        theme,
        autoContrast
      }) : void 0
    }
  };
});
const Tabs = factory((_props, ref) => {
  const props = useProps("Tabs", defaultProps, _props);
  const {
    defaultValue,
    value,
    onChange,
    orientation,
    children,
    loop,
    id,
    activateTabWithKeyboard,
    allowTabDeactivation,
    variant,
    color,
    radius,
    inverted,
    placement,
    keepMounted,
    classNames,
    styles,
    unstyled,
    className,
    style,
    vars,
    autoContrast,
    mod,
    ...others
  } = props;
  const uid = useId(id);
  const [currentTab, setCurrentTab] = useUncontrolled({
    value,
    defaultValue,
    finalValue: null,
    onChange
  });
  const getStyles = useStyles({
    name: "Tabs",
    props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(TabsProvider, {
    value: {
      placement,
      value: currentTab,
      orientation,
      id: uid,
      loop,
      activateTabWithKeyboard,
      getTabId: getSafeId(`${uid}-tab`, VALUE_ERROR),
      getPanelId: getSafeId(`${uid}-panel`, VALUE_ERROR),
      onChange: setCurrentTab,
      allowTabDeactivation,
      variant,
      color,
      radius,
      inverted,
      keepMounted,
      unstyled,
      getStyles
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
      ref,
      id: uid,
      variant,
      mod: [{
        orientation,
        inverted: orientation === "horizontal" && inverted,
        placement: orientation === "vertical" && placement
      }, mod],
      ...getStyles("root"),
      ...others,
      children
    })
  });
});
Tabs.classes = classes;
Tabs.displayName = "@mantine/core/Tabs";
Tabs.Tab = TabsTab;
Tabs.Panel = TabsPanel;
Tabs.List = TabsList;
export { Tabs };